export default __webpack_public_path__ + "017a917356939a897dba799525c99ae2.gif";